/**
 * AnglesTab — T26.
 * Per-product library editor for the 'angle' parameter type.
 * Writers and above can create/edit/archive/revert.
 */
import LibraryEditor from './LibraryEditor';

interface AnglesTabProps {
  canWrite: boolean;
}

export default function AnglesTab({ canWrite }: AnglesTabProps) {
  return <LibraryEditor type="angle" canWrite={canWrite} perProduct />;
}
